// Konten terpusat untuk website PT. Aneka Jaringan Energy (AJE)

export const COMPANY = {
  name: "PT. Aneka Jaringan Energy",
  short: "AJE",
  tagline: "Ready to start a project of any complexity.",
  taglineId: "Siap mengerjakan proyek energi surya dengan kompleksitas apa pun.",
  parent: "Aneka Jaringan Holding Bhd (Malaysia)",
  logo: "/assets/aje-logo.png",
  address:
    "Rukan Bukit Gading Mediterania Blok EB03, Jl. Boulevard Bukit Gading Raya, Kelapa Gading, Jakarta Utara, DKI Jakarta 14240",
  phone: "",
  phoneRaw: "",
  whatsapp: "",
  whatsappRaw: "",
  email: "business@ajenergy.co.id",
  hours: "Senin – Jumat: 08.30 – 17.30 WIB",
  linkedin: "https://linkedin.com/company/ajenergy",
};

export const IMAGES = {
  heroFarm:
    "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  rooftopCommercial:
    "https://images.unsplash.com/photo-1620492948585-c97e18c173dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  officeAerial:
    "https://images.unsplash.com/photo-1758304481667-71d545c91241?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  farmRows:
    "https://images.unsplash.com/photo-1629726797843-618688139f5a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  engineer1:
    "https://images.unsplash.com/photo-1668097613572-40b7c11c8727?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  engineer2:
    "https://images.unsplash.com/photo-1726221062299-88f27b653c59?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  engineer3:
    "https://images.unsplash.com/photo-1719848576338-9516ba7ccd8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  streetLight:
    "https://images.unsplash.com/photo-1740805276608-ef60e2e468ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  // Foto proyek asli AJE
  projectBSD: "/assets/project-bsd.jpg",
  projectRooftop: "/assets/project-rooftop.jpg",
  install: "/assets/install.jpg",
  waterpump: "/assets/solar-water-pump.jpg",
  maintenance: "/assets/maintenance.jpg",
  coldroom: "/assets/coldroom.jpg",
  farmGrass: "/assets/plts-terapung.jpeg",
  panel: "/assets/panel.jpg",
  danoneJogja: "/assets/danoneJogja.webp",
  aryadutaMedan: "/assets/aryadutaMedan.jpg",
  depoLampung: "/assets/depoLampung.webp",
  corMorowali: "/assets/corMorowali.jpeg",
  modenaMedan: "/assets/modenaMedan.jpg",
};

export const PILLARS = [
  {
    icon: "ShieldCheck",
    title: "Reliable",
    desc: "A member of Aneka Jaringan Holdings Bhd Group Malaysia. We execute every installation with high quality standards to deliver the long-lasting durability we promise.",
  },
  {
    icon: "Lightbulb",
    title: "Innovative",
    desc: "No matter the location or technical challenge, we deliver solutions through engineering expertise, advanced solar technology, and IoT monitoring.",
  },
  {
    icon: "Leaf",
    title: "Sustainable",
    desc: "Through solar PV systems, we lower carbon footprints and deliver clean energy solutions that benefit both the planet and your business.",
  },
];

export const STATS = [
  { value: 25, suffix: "+ MWp", label: "Total Capacity Installed" },
  { value: 18, suffix: " Ton", label: "CO₂ Reduction per Year" },
  { value: 120, suffix: "+", label: "Completed Projects" },
  { value: 95, suffix: "%", label: "Client Satisfaction" },
];

export const VALUES = [
  {
    icon: "TrendingUp",
    title: "Investments",
    titleId: "Value Investment",
    desc: "We prioritize profitability through environmental conservation. Our smart systems significantly reduce operational costs and cut emissions.",
  },
  {
    icon: "Recycle",
    title: "Sustainability",
    titleId: "Sustainability",
    desc: "We balance resource conservation with the production of high-quality energy for a better life, which is our responsibility.",
  },
  {
    icon: "Award",
    title: "Excellence",
    titleId: "Excellence",
    desc: "We strive for excellence in every project, delivering innovative solutions that exceed our clients' expectations.",
  },
  {
    icon: "GitBranch",
    title: "Choices",
    titleId: "Flexible Options",
    desc: "You set the path toward a greener planet. We show you the way and deliver the right solutions tailored to your needs.",
  },
];

export const SERVICES = [
  {
    id: "photovoltaic",
    icon: "Sun",
    title: "Sistem Photovoltaic (Grid-Tied, Off-Grid & Hybrid)",
    short: "Comprehensive solar PV solutions, including grid-connected, standalone (off-grid), and hybrid systems integrated with battery storage.",
    img: "rooftopCommercial",
    detail:
      "We design and deliver complete solar PV systems across various scales. Grid-Tied systems are the most economical and virtually maintenance-free option, ideal for offices and malls operating during the day. Off-Grid systems are designed for remote locations without grid access, integrated with battery storage. Hybrid systems combine solar energy and the grid for an uninterruptible power supply (UPS), effectively replacing conventional generators.",
  },
  {
    id: "solar-farm",
    icon: "Factory",
    title: "Solar Farms & EPC Turnkey",
    short: "Comprehensive solar farm solutions from feasibility study to large-scale installation (MWp).",
    img: "farmRows",
    detail:
      "Utility-scale solar PV projects (MWp-scale) where Ours acts as the EPC partner. Every project starts with a rigorous Feasibility Study analyzing geotechnical factors, structural safety, electrical grids, and system design — a critical prerequisite for IPP investor decision-making.",
  },
  {
    id: "telco",
    icon: "RadioTower",
    title: "Operation & Maintenance Solar Panel",
    short: "Comprehensive solar panel O&M solutions for remote telecommunications infrastructure.",
    img: "engineer1",
    detail:
      "Comprehensive O&M (Operations & Maintenance) services to ensure optimal performance, maximum energy output, and long-term system reliability.",
  },
  {
    id: "lighting",
    icon: "Lightbulb",
    title: "Solar Lighting & PJU Pintar",
    short: "Energy-efficient Solar Street Lighting (PJUTS) equipped with intelligent control systems.",
    img: "streetLight",
    detail:
      "A wide range of solar lighting systems featuring high-efficiency DC LEDs and smart storage and control systems. Comes with a 1–2 year warranty for most products equipped with long-lasting Lithium Iron Phosphate (LiFePO₄) batteries. Applications include: solar street lighting (PJU), security lights, solar home systems, courtyard lights, billboards, and mobile light towers.",
  },
  {
    id: "monitoring",
    icon: "Activity",
    title: "Sistem Monitoring & Kontrol IoT",
    short: "Real-time power monitoring dashboard via smartphone and desktop.",
    img: "engineer2",
    detail:
      "Advanced monitoring system to track real-time power generation across mobile and desktop devices. It enables seamless daily efficiency analysis and predictive maintenance to ensure optimal solar PV performance at all times.",
  },
  {
    id: "floating",
    icon: "Waves",
    title: "Floating Solar",
    short: "Modular floating solar installations made from HDPE for reservoirs and lakes.",
    img: "farmGrass",
    detail:
      "Advanced floating solar structure featuring a revolutionary HDPE (High Density Polyethylene) design that is robust, chemical-resistant, fireproof, UV-resistant, and corrosion-proof. It can support loads up to 350kg/m². The construction is fast, efficient, requires no heavy machinery, and protects aquatic environments.",
  },
  {
    id: "heating-cooling",
    icon: "Thermometer",
    title: "Cold Storage",
    short: "Energy-efficient solar water heating and cold storage solutions.",
    img: "coldroom",
    detail:
      "Solar water heating solutions for medical facilities, hotels, manufacturing plants, livestock farms, and swimming pools. AJE also develops 100% solar-powered off-grid cold storage utilizing Thermal Energy Storage (TES) technology — ideal for remote agricultural and fishing communities. Solar-assisted air conditioning systems are also available.",
  },
  {
    id: "water-pumping",
    icon: "Droplets",
    title: "Solar Water Pumping System",
    short: "Energy-efficient solar water pumping solutions for irrigation and clean water supply.",
    img: "waterpump",
    detail:
      "Solar water pumping systems are highly efficient as they generally do not require battery storage — water is pumped during daylight hours and stored in tanks. AJE utilizes German-engineered Lorentz pumps, renowned for their exceptional efficiency and lifespan of up to 20 years, capable of pumping from depths of up to 240 meters and delivering over 100 m³ of water per day.",
  },
];

export const COMPONENTS = [
  "Solar Modules (Tier-1 PV Panels)",
  "Industrial Inverters",
  "Lithium Batteries",
  "Cables & Wiring",
  "Lightning Protection Systems",
];

export const BRANDS = [
  { name: "Jinko Solar", logo: "/assets/jinko.png" },
  { name: "LONGi", logo: "/assets/longi.png" },
  { name: "Trina Solar", logo: "/assets/trina.png" },
  { name: "Huawei", logo: "/assets/huawei.png" },
  { name: "Sungrow", logo: "/assets/sungrow.png" },
  { name: "SMA", logo: "/assets/sma.jpg" },
];

export const PROJECTS = [
  {
  name: "Danone Factory Jogja",
  type: "Pabrik & Industri",
  capacity: "1,5 MWp",
  location: "DI Yogyakarta",
  impact: "Accelerating the Green Energy Transition for Manufacturing",
  img: "danoneJogja" 
},
{
  name: "Aryaduta Hotel Medan",
  type: "Atap Komersial",
  capacity: "350 kWp",
  location: "Medan, North Sumatra",
  impact: "Renewable Energy Solutions for the Hospitality Sector",
  img: "aryadutaMedan"
},
{
  name: "Depo Bangunan Lampung",
  type: "Atap Komersial",
  capacity: "500 kWp",
  location: "Bandar Lampung, Lampung",
  impact: "Optimizing Operational Costs in the Commercial Retail Sector",
  img: "depoLampung"
},
{
  name: "COR Industrial Complex Morowali",
  type: "Pabrik & Industri",
  capacity: "2,4 MWp",
  location: "Morowali, Central Sulawesi",
  impact: "Industrial-Scale Clean Energy Supply for Heavy Industry",
  img: "corMorowali"
},
{
  name: "Modena Thamrin Medan",
  type: "Atap Komersial",
  capacity: "200 kWp",
  location: "Medan, North Sumatra",
  impact: "Commercial Rooftop Solar Solutions",
  img: "modenaMedan"
}
];


export const ARTICLES = [
  {
    id: "panduan-plts-atap-2026",
    title: "Comprehensive Guide: Industrial Rooftop Solar Deployment in Indonesia 2026",
    category: "Regulasi & Edukasi",
    date: "12 Juli 2026",
    read: "6 minutes",
    img: "rooftopCommercial",
    excerpt:
      "Latest industrial rooftop solar regulations, PLN grid feed-in dynamics, and payback period calculations for businesses.",
    body: [
      "Commercial and industrial sectors in Indonesia are increasingly adopting rooftop solar PV systems. Beyond reducing operational electricity costs, rooftop solar supports corporate Net Zero Emission targets and ESG commitments.",
      "Prior to installation, enterprises must evaluate roof structural capacity, daily load profiles, and applicable PLN interconnection regulations. Grid-tied systems remain the most favored choice due to their cost-efficiency and minimal maintenance requirements.",
      "AJE supports clients through every stage—from feasibility studies (soil, structural, electrical, and system design) and Tier-1 component procurement to construction, commissioning, and continuous monitoring. Through an integrated EPC approach, all technical risks are managed by a single trusted partner.",
      "The estimated payback period for commercial installations typically ranges between 4 to 6 years, whereas solar panels offer an operational lifespan of up to 25 years. This positions rooftop solar PV as a high-yield, long-term investment with attractive ROI.",
    ],
  },
  {
    id: "cara-hitung-roi-solar-panel",
    title: "Calculating ROI & OPEX Savings with Commercial Solar PV",
    category: "Finansial & Bisnis",
    date: "05 Juni 2026",
    read: "5 minutes",
    img: "engineer2",
    excerpt:
      "Simulating industrial electricity bill savings of hundreds of millions of rupiah per month with AJE’s Grid-Tied system.",
    body: [
      "Return on Investment (ROI) is the primary metric when evaluating a solar PV project. The calculation is straightforward: compare the total capital expenditure against the cumulative electricity bill savings over the system's operational lifespan.",
      "For illustration, a manufacturing plant with a monthly electricity bill of IDR 150 million can potentially save up to 60–70% on daytime energy costs by deploying a targeted Grid-Tied solar system.",
      "Use our Solar Savings Estimator Calculator on the home page to estimate your required kWp capacity, annual cost savings, payback period, and CO₂ emissions reduction.",
      "The AJE technical team is ready to deliver a precise financial study based on your actual load profile and site-specific conditions.",
    ],
  },
  {
    id: "perbedaan-grid-tied-vs-hybrid",
    title: "Comparing On-Grid, Off-Grid, and Hybrid Solar Systems — Which System Fits Your Business?",
    category: "Teknologi Solar",
    date: "18 Mei 2026",
    read: "7 minutes",
    img: "farmGrass",
    excerpt:
      "Understanding the characteristics of each solar PV system configuration to match your plant’s load reliability requirements.",
    body: [
      "Selecting the appropriate solar PV system type dictates the overall efficiency and financial yield of your investment. There are three primary configurations: On-Grid (Grid-Tied), Off-Grid, and Hybrid.",
      "Grid-Tied systems are the most streamlined and cost-effective solution, requiring only synchronization with PLN’s voltage and frequency. This configuration is ideal for facilities with primary electricity consumption occurring during daytime hours.",
      "Off-Grid systems are designed for remote locations without access to the PLN grid, utilizing battery energy storage to supply power overnight. This system carries a higher capital cost due to battery replacement cycles every few years.",
      "Hybrid systems combine the advantages of both configurations, delivering uninterrupted power supply with battery backup during grid outages. This option is critical for facilities requiring high power reliability, such as hospitals and data centers.",
    ],
  },
];
